import { render, staticRenderFns } from "./IntelligenceView.vue?vue&type=template&id=64b389ce&scoped=true"
import script from "./IntelligenceView.vue?vue&type=script&lang=js"
export * from "./IntelligenceView.vue?vue&type=script&lang=js"
import style0 from "./IntelligenceView.vue?vue&type=style&index=0&id=64b389ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b389ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64b389ce')) {
      api.createRecord('64b389ce', component.options)
    } else {
      api.reload('64b389ce', component.options)
    }
    module.hot.accept("./IntelligenceView.vue?vue&type=template&id=64b389ce&scoped=true", function () {
      api.rerender('64b389ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Intelligence/IntelligenceView.vue"
export default component.exports